let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i707i")).then(() => parcelRequire('1trQq'));